import React from "react";
import useModal from "../../common/components/modals/useModal";

import { SearchesActions } from "../searches/SearchesActions";
import useSearches from "../searches/useSearches";
import { advancedSearchAdditionalLinkType } from "../../common/types/search/search";

export interface AdvancedSearchFooterProps {
	advancedSearchAdditionalLink?: advancedSearchAdditionalLinkType;
	onClearClick: React.MouseEventHandler<HTMLButtonElement>;
	onSearchClick: React.MouseEventHandler<HTMLButtonElement>;
	namespace: string;
	searchesEnabled: boolean;
}

export function AdvancedSearchFooter({
	advancedSearchAdditionalLink,
	namespace,
	onClearClick,
	onSearchClick,
	searchesEnabled,
}: AdvancedSearchFooterProps) {
	const { current, searchDirty, updateSearch } = useSearches(namespace);
	const { clearModals } = useModal([]);

	return (
		<footer className="modal__actions">
			<div className="actions__container">
				<div className="actions__group">
					{searchesEnabled && (
						<SearchesActions
							current={current}
							searchDirty={searchDirty}
							updateSearch={updateSearch}
						/>
					)}
				</div>
				<div className="actions__group">
					{advancedSearchAdditionalLink}
					<button
						type="button"
						className="btn btn--link btn--clear"
						onClick={onClearClick}
					>
						Clear All
					</button>
					<button
						type="button"
						className="btn btn--tertiary"
						onClick={clearModals}
					>
						Cancel
					</button>
					<button
						type="button"
						className="btn btn--primary"
						onClick={onSearchClick}
					>
						Apply Filters
					</button>
				</div>
			</div>
		</footer>
	);
}
